export const ArrowIconBase64 =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAMCAYAAAC0qUeeAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAXklEQVQoz2MQ3hRxAIgT/v//z0AIM4AUAvF/IL4AxA54FYMIqML/UAyySQGfYgckxTC8AIgFMBRDNRzAouEDEDfANCErVsCiGIYfgPxGtmLinEGSB4kOOpIihZToBgA6zDrCsSHkoAAAAABJRU5ErkJggg=="

